import React from 'react'
import { useAuthStore } from '../AuthStore'
import PropTypes from 'prop-types';
import EnergyApi from './EnergyApi'

export const EnergyApiContext = React.createContext<EnergyApi>({} as EnergyApi);

export const EnergyApiProvider: React.FC = ({ children }) => {
  const store = useAuthStore();
  const api = new EnergyApi(store);

  return (
    <EnergyApiContext.Provider value={api} > {children} </EnergyApiContext.Provider>
  )
}

EnergyApiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useEnergyApi = (): EnergyApi => React.useContext(EnergyApiContext);
